import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import axios from "axios";
import { useState } from "react";

export default function DeleteAssetModal({
  assetId,
  assetName,
  refreshAssets,
  handleClose,
}) {
  const url = process.env.REACT_APP_URL;
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const handleDeleteAsset = async () => {
    const reqBody = {
      assetId: assetId,
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
    };

    await axios
      .post(`${url}/assets/delete-asset`, reqBody)
      .then((res) => {
        handleAlert("Asset has been deleted", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  return (
    <Box className="delete-asset-modal">
      <section className="delete-asset-section">
        <h2>Delete Asset</h2>
        <p>
          You are about to delete Asset: <b>{assetName}</b>. Please ensure you
          are confident about this. If this action needs reversed afterward
          please contact the development team.
        </p>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            Close
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleDeleteAsset}
            disabled={disable}
          >
            Delete
          </Button>
        </section>
      </section>
    </Box>
  );
}
